import React, { useEffect, useState } from 'react';
import {
  getRoles,
  createRol,
  editRol,
  deleteRol,
  getPermisosByRol,
  assignPermisosToRol,
  removePermisosFromRol
} from '../../services/Admin/rolService';
import { getPermisos, createPermiso, editPermiso, deletePermiso } from '../../services/Admin/permisosService';
import ReusableTable from '../../components/ReusableTable';
import CreateButton from '../../components/CreateButton';
import EditButton from '../../components/EditButton';
import DeleteButton from '../../components/DeleteButton';
import GestionarPermisosModal from '../../components/GestionarPermisosModal';

const columns = [
  { key: 'id_rol', label: 'ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'estado', label: 'Estado' }
];

const formConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

const permisosColumns = [
  { key: 'id_permisos', label: 'ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'descripcion', label: 'Descripción' },
  { key: 'estado', label: 'Estado' }
];

const permisosFormConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

const RolPage = () => {
  const [roles, setRoles] = useState([]);
  const [reload, setReload] = useState(false);
  const [managePermisosOpen, setManagePermisosOpen] = useState(false);
  const [selectedRol, setSelectedRol] = useState(null);
  const [permisos, setPermisos] = useState([]);
  const [reloadPermisos, setReloadPermisos] = useState(false);
  const [permisosAsignados, setPermisosAsignados] = useState([]);
  const [loadingPermisosRol, setLoadingPermisosRol] = useState(false);

  useEffect(() => {
    getRoles().then(setRoles);
  }, [reload]);

  useEffect(() => {
    getPermisos().then(setPermisos);
  }, [reloadPermisos]);

  const handleCreate = async (values, cb) => {
    const success = await createRol(values);
    if (success) setReload(r => !r);
    cb(success);
  };

  const handleEdit = item => async (values, cb) => {
    const success = await editRol(item.id_rol, values);
    if (success) setReload(r => !r);
    cb(success);
  };

  const handleDelete = item => async cb => {
    const success = await deleteRol(item.id_rol);
    if (success) setReload(r => !r);
    cb(success);
  };

  const handleCreatePermiso = async (values, cb) => {
    const success = await createPermiso(values);
    if (success) setReloadPermisos(r => !r);
    cb(success);
  };

  const handleEditPermiso = item => async (values, cb) => {
    const success = await editPermiso(item.id_permisos, values);
    if (success) setReloadPermisos(r => !r);
    cb(success);
  };

  const handleDeletePermiso = item => async cb => {
    const success = await deletePermiso(item.id_permisos);
    if (success) setReloadPermisos(r => !r);
    cb(success);
  };

  const handleOpenGestionarPermisos = async rol => {
    setSelectedRol(rol);
    setManagePermisosOpen(true);
    setLoadingPermisosRol(true);
    try {
      const permisosRol = await getPermisosByRol(rol.id_rol);
      // Normaliza los IDs a string para coincidencia exacta en el modal
      setPermisosAsignados(permisosRol.map(p => String(p.id_permisos)));
    } finally {
      setLoadingPermisosRol(false);
    }
  };

  const handleCloseGestionarPermisos = () => {
    setManagePermisosOpen(false);
    setSelectedRol(null);
    setPermisosAsignados([]);
  };

  const handleGuardarPermisosRol = async (selectedPermisos, cb) => {
    if (!selectedRol) return;
    const originales = permisosAsignados;
    const nuevos = selectedPermisos;
    const aAsignar = nuevos.filter(id => !originales.includes(id));
    const aRemover = originales.filter(id => !nuevos.includes(id));
    let ok = true;
    if (aAsignar.length > 0) {
      ok = ok && (await assignPermisosToRol(selectedRol.id_rol, aAsignar));
    }
    if (aRemover.length > 0) {
      ok = ok && (await removePermisosFromRol(selectedRol.id_rol, aRemover));
    }
    if (ok) setReloadPermisos(r => !r);
    cb(ok);
    handleCloseGestionarPermisos();
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Gestión de Roles</h2>
      <CreateButton formConfig={formConfig} onCreate={handleCreate} />
      <ReusableTable
        data={roles}
        columns={columns}
        actionRender={item => (
          <>
            <EditButton item={item} formConfig={formConfig} onEdit={handleEdit(item)} />
            <DeleteButton item={item} onDelete={handleDelete(item)} />
          </>
        )}
      />
      {/* Elimino el modal de gestionar permisos, la gestión de permisos y la tabla de permisos */}
    </div>
  );
};

export default RolPage;